import { CarTypesEnum } from '@/components/car-details-v2/car-type';
import Image from 'next/image';
import { CarCertified, CarLite, CarDealer } from 'public/Images';
import { useTranslation } from 'react-i18next';

export const CarTypeBadge = ({
    carType,
    className = '',
    style = {},
}: {
    carType: CarTypesEnum;
    className?: string;
    style?: React.CSSProperties;
}) => {
    const { t } = useTranslation();
    const badgeMap: Record<CarTypesEnum, JSX.Element> = {
        [CarTypesEnum.CERTIFIED]: (
            <Badge
                src={CarCertified}
                title={t('CarProfile.CarType.certified')}
                className={`bg-certified-600 ${className}`}
                style={style}
            />
        ),
        [CarTypesEnum.LITE]: (
            <Badge
                src={CarLite}
                title={t('CarProfile.CarType.lite')}
                className={`bg-lite-600 ${className}`}
                style={style}
            />
        ),
        [CarTypesEnum.Dealer]: (
            <Badge
                src={CarDealer}
                title={t('CarProfile.CarType.dealer')}
                className={`bg-dealer-600 ${className}`}
                style={style}
            />
        ),
    };

    return <>{badgeMap[carType]}</>;
};

const Badge = ({
    src,
    title,
    className,
    style,
}: {
    title: string;
    className: string;
    style?: React.CSSProperties;
    src: any;
}) => {
    return (
        <div
            className={`${className} py-1 px-3 flex gap-x-1 justify-center items-center`}
            style={style}
        >
            <Image
                src={src}
                alt="certified"
                width={14}
                className="flex-shrink-0"
            />
            <div className="text-white text-caption2SemiBold mt-0.5">
                {title}
            </div>
        </div>
    );
};
